export default __webpack_public_path__ + "static/media/services_mobile_app_development.bb938476.png";